import React from 'react';
import './BodySection4.css';

// Import the images (make sure to replace with actual image paths)
import img1 from './bodyimages/cadd-e1483707663979.png'; 
import img2 from './bodyimages/Cisco_logo_emblem_logotype-e1483707631292.png'; 
import img3 from './bodyimages/download (1).png';
import img4 from './bodyimages/download (2).png';
import img5 from './bodyimages/download (3).png';
import img6 from './bodyimages/download.jpg';
import img7 from './bodyimages/download.png';
import img8 from './bodyimages/Tech_Mahindra-Logo.wine.png';
import img9 from './logo company/1630621156440.jpeg';
import img10 from './logo company/1631354840069.jpeg';
import img11 from './logo company/1669120408779 (1).jpeg';
import img12 from './logo company/AIM India Group Logo.avif';
import img13 from './logo company/1680697062606.jpeg';
import img14 from './logo company/1697524193403.jpeg';
import img15 from './logo company/Amber-Logo-on-white.png';
import img16 from './logo company/6afb52a14c9ca7086333a3e6675d5035.jpg';
import img17 from './logo company/9x3 Inch ACPL Logo.png';
import img18 from './logo company/anuthamindia_cover.jpeg';
import img19 from './logo company/c4.jpg';
import img20 from './logo company/cloudfireireland_logo.jpeg';
import img21 from './logo company/emson-gears-ltd.jpg';
import img22 from './logo company/download (2).png';
import img23 from './logo company/gkn-automotive-logo-png_seeklogo-61035.png';
import img24 from './logo company/Hyundai_Motor_Group_CI.svg.png';
import img25 from './logo company/images (1).jpeg';
import img26 from './logo company/images (10).jpeg';
import img27 from './logo company/images (11).jpeg';
import img28 from './logo company/images (12).png';
import img29 from './logo company/images (13).png';
import img30 from './logo company/images (14).png';
import img31 from './logo company/images (15).png';
import img32 from './logo company/images (16).png';
import img33 from './logo company/images (2).jpeg';
import img34 from './logo company/images (3).jpeg';
import img35 from './logo company/images (3).png';
import img36 from './logo company/images (4).jpeg';
import img37 from './logo company/images (4).png';
import img38 from './logo company/images (5).jpeg';
import img39 from './logo company/images (5).png';
import img40 from './logo company/images (6).jpeg';
import img41 from './logo company/images (6).png';
import img42 from './logo company/images (7).jpeg';
import img43 from './logo company/images (7).png';
import img44 from './logo company/images (8).jpeg';
import img45 from './logo company/images (8).png';
import img46 from './logo company/images (9).jpeg';
import img47 from './logo company/images (9).png';
import img48 from './logo company/images.jpeg';
import img49 from './logo company/indo-auto-tech.jpg';
import img50 from './logo company/lacbtcztaszbyhjeavjn.webp';
import img51 from './logo company/Logo-Tabsons-India.png';
import img52 from './logo company/logo.png';
import img53 from './logo company/ltgrouplogo.webp';
import img54 from './logo company/lucastvs_logo.jpeg';
import img55 from './logo company/methodex_systems_ltd_logo.jpeg';
import img56 from './logo company/microsoft-ssis.png';
import img57 from './logo company/og-image.png';
import img58 from './logo company/olslogopng.png';
import img59 from './logo company/pheuture_studio_pvt_ltd_logo.jpeg';
import img60 from './logo company/PICL-logo.png';
import img61 from './logo company/premier_plasmotec_private_limited_logo.jpeg';
import img62 from './logo company/Scaler-HT-1- (1).png';
import img63 from './logo company/talent.jpeg';
import img64 from './logo company/techmash_software_solutions_private_ltd_cover.jpeg';
import img65 from './logo company/unnamed (1).png';
import img66 from './logo company/WpcTavg99b5XpK6STzSLZ8.jpg';
import img67 from './logo company/yamaha-logo-design-template-2a186d04b863b074df7c64226ab79f4b_screen.jpg';
import img68 from './logo company/unnamed (1).png';
import img69 from './logo company/unnamed.png';
import img70 from './logo company/c4.jpg';
import img71 from './bodyimages/auto_ignition_ltd_logo.jpeg';
import img72 from './bodyimages/bar-logo.jpg';
import img73 from './bodyimages/dynamic-image.png';
import img74 from './bodyimages/HCL-logo.png'
import img75 from './bodyimages/hind-hydraulics-and-engineers-faridabad-sector-12-faridabad-rubber-industry-machinery-manufacturers-pw4yscsfux.avif';
import img76 from './bodyimages/images (1).jpeg';
import img77 from './bodyimages/images (1).png';
import img78 from './bodyimages/images (2).jpeg';
import img79 from './bodyimages/images (2).png';
import img80 from './bodyimages/images (3).jpeg';
import img81 from './bodyimages/download.jpg';
import img82 from './bodyimages/images (4).jpeg';
import img83 from './bodyimages/images (4).png';
import img84 from './bodyimages/images (5).png';
import img85 from './bodyimages/images (6).png';
import img86 from './bodyimages/images (7).png';
import img87 from './bodyimages/images (8).png';
import img88 from './bodyimages/images.jpeg';
import img89 from './bodyimages/images.png';
import img90 from './bodyimages/Jay Bharat Maruti Limited 2.jpg';
import img91 from './bodyimages/logo-sanden-vikas-india-ltd.jpg';
import img92 from './bodyimages/logo1.jpg';
import img93 from './bodyimages/Mahindra_Finance_SVG_Logo.svg.png';
import img94 from './bodyimages/Outlook-Sig.png';
import img95 from './bodyimages/priyanshu-building-materials-mirzapur-building-material-dealers-vhv3vwqa7l.jpg';
// import img96 from './bodyimages/Samsung_Logo';
import img97 from './bodyimages/sietz_technologies_india_pvt_ltd_logo.jpeg';
import img98 from './bodyimages/Tech_Mahindra-Logo.wine.png';
import img99 from './bodyimages/unnamed.gif';
import img100 from './logo company/c4.jpg';
// import img101 from './logo company/c4.jpg';
// import img102 from './logo company/c4.jpg';
// import img103 from './logo company/c4.jpg';
// import img104 from './logo company/c4.jpg';
// import img105 from './logo company/c4.jpg';
// import img106 from './logo company/c4.jpg';
// import img107 from './logo company/c4.jpg';
// import img108 from './logo company/c4.jpg';
// import img109 from './logo company/c4.jpg';

const BodySection4 = () => {
  // Array to store all the images
  const logos = [img1, img2, img3, img4, img5, img6, img7, img8,img9,img10,img11,img12,img13,img14,img15,img16,img17,img18,img19,img20,img21,img22,img23,img24,img25,img26,img27,img28,img29,img30,img31,img32,img33,img34,img35,img36,img37,img38,img39,img40,img41,img42,img43,img44,img45,img46,img47,img48,img49,img50,img51,img52,img53,img54,img55,img56,img57,img58,img59,img60,img61,img62,img63,img64,img65,img66,img67,img68,img69,img70,img71,img72,img73,img74,img75,img76,img77,img78,img79,img80,img81,img82,img83,img84,img85,img86,img87,img88,img89,img90,img91,img92,img93,img94,img95,img97,img98,img99,img100,]
  return (
    <div className='BodySection4-Container'>
        <h1 className='para'>Our Associations Companies </h1>
        <div className='bodysection4-1'>
          {logos.map((logo, index) => (
            <div key={index} className='logo-container'>
              <img src={logo} alt={`Logo ${index + 1}`} className='logo'/>
            </div>
          ))}
        </div>
    </div>
  );
}

export default BodySection4;

